
import { MainLayout } from "../components/layouts"
import { useState, useEffect } from "react"
import { Row, Col } from "reactstrap"
import { Card, ColorCircle, CustomButton, CustomInput, BackButton } from "../components"
import { COLORS } from "../constants"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { useHistory, Redirect } from "react-router-dom";
import Close from "../assets/images/Close.svg"
import styled from "styled-components"
import axios from "axios"
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
// const promise = loadStripe("pk_test_dtLz6QbAVwlVZ3TFsnf82GIQ00yvnYleIn");
const promise = loadStripe("pk_live_wesolxvDFvVkVNTn9hJvEF5t003E8tkEIC");

const StyledClose = styled.div`
    position: absolute;
    background-color: white;
    width: 40px;
    height: 40px;
    top: -15px;
    right: -15px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover{
        box-shadow: none;
    }

`;
function Checkout() {

    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user.user)
    const history = useHistory();
    const [basketData, setBasketData] = useState();
    const [items, setItems] = useState();
    const [error, setError] = useState(true);

    useEffect(async () => {

        const response = await axios.get(`${api}/ps/basket_contents/${user.email}`)
        const data = response.data;
    }, [])

    return (
        <MainLayout>
            <div className="d-flex align-items-center mt-4">
                <BackButton to="/store/basket" />
                <h4 className="mb-0 ml-4 color-text-dark-blue">Tell & Spell Store</h4>
            </div>

            <h5 className="mt-4 color-text-green">Checkout</h5>


            <Elements stripe={promise}>
                <CheckoutForm />
            </Elements>
        </MainLayout>
    );

}

export default Checkout;